import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from '@base'
import { Spacings, Text } from '@styles'

const Images = styled.div`
	display: flex;
	padding: ${Spacings.SPACING_4B};
	align-items: center;
	gap: ${Spacings.SPACING_2B};
	border-radius: ${Spacings.SPACING_2B};
	border: 1px solid ${({ theme }) => theme.palette.text.greyFive};
`

const Typography = styled.p`
	color: ${({ theme }) => theme.palette.text.greyFour};
	text-align: center;
	font-family: Poppins;
	font-size: ${Text.MEDIUM};
	font-style: normal;
	font-weight: ${Text.BOLD_400};
	line-height: 1.375rem; /* 157.143% */
`

const BaseCss = css`
	display: flex;
	flex-direction: column;
	padding: ${Spacings.SPACING_4B};
	align-items: center;
	gap: ${Spacings.SPACING_2B};
`

const LinkWapper = styled(Link)`
	${BaseCss};
`
const Container = styled.div`
	${BaseCss};
	cursor: pointer;
`

const ImageContent = ({ icon, title }) => (
	<>
		<Images>
			<img src={icon} alt={title || icon} />
		</Images>
		{title && (
			<div>
				<Typography>{title}</Typography>
			</div>
		)}
	</>
)

const ImageWapper = ({ icon, title, href, actionButton, onClick }) => {
	if (!actionButton)
		return (
			<LinkWapper href={href || '#'}>
				<ImageContent icon={icon} title={title} />
			</LinkWapper>
		)
	return (
		<Container onClick={onClick}>
			<ImageContent icon={icon} title={title} />
		</Container>
	)
}

export default ImageWapper
